import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../../../api/api';

export const useBookingApi = () => {
  const { t } = useTranslation();
  const [bookings, setBookings] = useState([]);
  const [error, setError] = useState("");

  const fetchGuestBookings = async (guestId) => {
    try {
      const response = await api.get(`/bookings/?guest_id=${encodeURIComponent(guestId)}`);
      setBookings(response.data);
    } catch (error) {
      console.error("Error fetching guest bookings:", error);
      setError(t("error_fetching_bookings"));
    }
  };

  const fetchOwnerBookings = async (ownerId) => {
    try {
      // Fetch owner's apartments
      const apartmentsResponse = await api.get(
        `/properties/apartments/?owner=${encodeURIComponent(ownerId)}`
      );
      
      const apartmentsData = apartmentsResponse.data;
      const apartmentIds = apartmentsData.map(apartment => apartment.id);

      // Fetch all bookings
      const bookingsResponse = await api.get('/bookings/');
      const bookingsData = bookingsResponse.data;

      // Filter bookings for owner's apartments
      const ownerBookings = bookingsData.filter(booking => 
        apartmentIds.includes(booking.apartment)
      );

      setBookings(ownerBookings);
    } catch (error) {
      console.error("Error fetching owner bookings:", error);
      setError(t("error_fetching_bookings"));
    }
  };

  const deleteBooking = async (bookingId) => {
    if (!window.confirm(t("confirm_delete_booking"))) return;

    try {
      await api.delete(`/bookings/${encodeURIComponent(bookingId)}/`);
      setBookings(prev => prev.filter(booking => booking.id !== bookingId));
      alert(t("booking_deleted_successfully"));
    } catch (error) {
      console.error("Error deleting booking:", error);
      alert(t("error_deleting_booking"));
    }
  };

const createOrUpdateBooking = async (bookingData, isUpdate = false) => {
    try {
      let response;
      if (isUpdate) {
        response = await api.put(`/bookings/${bookingData.id}/`, bookingData);
      } else {
        response = await api.post('/bookings/', bookingData);
      }

      alert(t("booking_created_updated_successfully"));
      
      // Refresh the bookings data
      const storedUserId = localStorage.getItem("user_id");
      const rawGroups = localStorage.getItem("groups");
      let storedGroups = [];

      if (rawGroups) {
        try {
          const parsed = JSON.parse(rawGroups);
          storedGroups = Array.isArray(parsed) ? parsed : [parsed];
        } catch {
          storedGroups = [rawGroups];
        }
      }

      const isGuest = storedGroups.some(group => String(group).trim() === "Guests");
      const isOwner = storedGroups.some(group => String(group).trim() === "Owners");

      if (isGuest) {
        await fetchGuestBookings(storedUserId);
      } else if (isOwner) {
        await fetchOwnerBookings(storedUserId);
      }

      return response.data;
    } catch (error) {
      console.error("Booking error:", error);
      throw error;
    }
  };

  return {
    bookings,
    setBookings,
    fetchGuestBookings,
    fetchOwnerBookings,
    deleteBooking,
    createOrUpdateBooking,
    error,
    setError
  };
};